export const UPDATE_CUSTOMER_EMAIL = 'UPDATE_CUSTOMER_EMAIL'
export const SET_CUSTOMER_INFO = 'SET_CUSTOMER_INFO'
export const SET_API_ACTION_FEEDBACK_PROFILE = 'SET_API_ACTION_FEEDBACK_PROFILE'
export const EMAIL_EXISTS_STATUS = 'EMAIL_EXISTS_STATUS'
export const EMAIL_STATUS_VERIFYING = 'EMAIL_STATUS_VERIFYING'
